import React from "react";

export const DEFAULT_AI_AGENT_AVATAR = "orbita";

function BotGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M12 8V4" />
			<path d="M8 4h8" />
			<rect x="4" y="8" width="16" height="12" rx="4" />
			<path d="M9 13h.01M15 13h.01" />
			<path d="M9 17h6" />
		</svg>
	);
}

function ChatGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z" />
			<path d="M8 9h8M8 13h5" />
		</svg>
	);
}

function ShieldGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M12 3 5 6v6c0 5 3.5 8.5 7 9 3.5-.5 7-4 7-9V6l-7-3Z" />
			<path d="m9.5 12 1.5 1.5 3.5-3.5" />
		</svg>
	);
}

function RocketGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M4.5 16.5c-1.5 1.5-1.5 3.5-1.5 3.5s2 0 3.5-1.5 1.5-3.5 1.5-3.5-2 0-3.5 1.5Z" />
			<path d="M12 15 9 12c0-5 3-8 8-8 0 5-3 8-8 8Z" />
			<path d="M15 9h.01" />
			<path d="m12 15 3 3" />
		</svg>
	);
}

function StarGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="currentColor">
			<path d="m12 2 2.2 5.8L20 10l-5.8 2.2L12 18l-2.2-5.8L4 10l5.8-2.2Z" />
		</svg>
	);
}

function BookGlyph({ className = "size-7" }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
			<path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
		</svg>
	);
}

export const AI_AGENT_AVATAR_OPTIONS = [
	{
		id: "orbita",
		label: "Órbita",
		description: "Assistente equilibrado e versátil.",
		icon: "bot",
		frameClassName:
			"bg-gradient-to-br from-sky-100 via-white to-indigo-100 text-sky-600 ring-sky-200/80 dark:from-sky-500/20 dark:via-default-900 dark:to-indigo-500/20 dark:text-sky-300 dark:ring-sky-500/20",
	},
	{
		id: "pulse",
		label: "Pulse",
		description: "Tom ágil e dinâmico para atendimento.",
		icon: "chat",
		frameClassName:
			"bg-gradient-to-br from-emerald-100 via-white to-cyan-100 text-emerald-600 ring-emerald-200/80 dark:from-emerald-500/20 dark:via-default-900 dark:to-cyan-500/20 dark:text-emerald-300 dark:ring-emerald-500/20",
	},
	{
		id: "guardiao",
		label: "Guardião",
		description: "Perfil mais seguro e institucional.",
		icon: "shield",
		frameClassName:
			"bg-gradient-to-br from-amber-100 via-white to-orange-100 text-amber-600 ring-amber-200/80 dark:from-amber-500/20 dark:via-default-900 dark:to-orange-500/20 dark:text-amber-300 dark:ring-amber-500/20",
	},
	{
		id: "nova",
		label: "Nova",
		description: "Avatar moderno para respostas criativas.",
		icon: "star",
		frameClassName:
			"bg-gradient-to-br from-fuchsia-100 via-white to-pink-100 text-fuchsia-600 ring-fuchsia-200/80 dark:from-fuchsia-500/20 dark:via-default-900 dark:to-pink-500/20 dark:text-fuchsia-300 dark:ring-fuchsia-500/20",
	},
	{
		id: "turbo",
		label: "Turbo",
		description: "Foco em velocidade e conversão.",
		icon: "rocket",
		frameClassName:
			"bg-gradient-to-br from-violet-100 via-white to-blue-100 text-violet-600 ring-violet-200/80 dark:from-violet-500/20 dark:via-default-900 dark:to-blue-500/20 dark:text-violet-300 dark:ring-violet-500/20",
	},
	{
		id: "sage",
		label: "Sage",
		description: "Ideal para agentes consultivos e técnicos.",
		icon: "book",
		frameClassName:
			"bg-gradient-to-br from-slate-100 via-white to-zinc-100 text-slate-600 ring-slate-200/80 dark:from-slate-500/20 dark:via-default-900 dark:to-zinc-500/20 dark:text-slate-300 dark:ring-slate-500/20",
	},
];

export function getAgentAvatarOption(avatarId) {
	return (
		AI_AGENT_AVATAR_OPTIONS.find((option) => option.id === avatarId) ||
		AI_AGENT_AVATAR_OPTIONS.find((option) => option.id === DEFAULT_AI_AGENT_AVATAR)
	);
}

function renderGlyph(icon, className) {
	switch (icon) {
		case "chat":
			return <ChatGlyph className={className} />;
		case "shield":
			return <ShieldGlyph className={className} />;
		case "rocket":
			return <RocketGlyph className={className} />;
		case "star":
			return <StarGlyph className={className} />;
		case "book":
			return <BookGlyph className={className} />;
		case "bot":
		default:
			return <BotGlyph className={className} />;
	}
}

export function AgentAvatar({
	avatarId,
	className = "size-16 rounded-full",
	iconClassName = "size-8",
}) {
	const option = getAgentAvatarOption(avatarId);

	return (
		<div
			className={`inline-flex items-center justify-center ring-1 ${option.frameClassName} ${className}`.trim()}
		>
			{renderGlyph(option.icon, iconClassName)}
		</div>
	);
}
